import React from "react";
import PageLoader from "../../components/PageLoader";

import loadable from "@loadable/component";

export default loadable(e => import("./homework"), { fallback: <PageLoader /> });
